import React from 'react';

const FundSelection = ({
  selectedCompanies,
  selectedFunds,
  onFundSelect,
  fundsData
}) => {

  const [loading, setLoading] = React.useState(true);

  const COMPANY_THEME = {


    TATA: {
      thColor: '#C8102E',
      selectedBg: '#fdecea',
      isTata: true
    },


    HDFC: {
      thColor: '#16a34a',
      selectedBg: 'rgb(212, 236, 210)'
    }

  };

  React.useEffect(() => {
    setLoading(false);
  }, [fundsData]);

  if (loading) {
    return <div>Loading funds...</div>;
  }

  if (!fundsData || fundsData.length === 0) {
    return <div>No funds found</div>;
  }

  return (
    <>
      {[...fundsData].map((comp) => {

      
        if (!selectedCompanies[comp._id]) {
          return null;
        }

        let companyType = '';

        if (comp.tabName) {
          companyType =
            comp.tabName.toUpperCase();
        }

        else if (comp.companyName) {
          companyType =
            comp.companyName.toUpperCase();
        }

        else if (
          comp.name?.includes('Competitor T')
        ) {
          companyType = 'TATA';
        }

        else if (
          comp.name?.includes('Competitor H')
        ) {
          companyType = 'HDFC';
        }

        else {
          companyType = 'ICICI';
        }

    
        const theme =
          COMPANY_THEME[companyType] || {};

      
        const thColor =
          theme.thColor || '#1A2B5F';

        const selectedBg =
          theme.selectedBg || '#e8edf7';

        const isTata =
          theme.isTata || false;

        return (

          <div
            key={comp._id}
            className="fund-section"
          >

            <div className="fund-section-title">

              {comp.name}

              {isTata && ' ⭐'}

            </div>

        <div className="fund-table-wrapper">

              <table className="fund-table">

             <thead>
  <tr>
    <th style={{ background: thColor }}>○</th>

    <th style={{ background: thColor }}>
      Fund Name
    </th>

    <th style={{ background: thColor }}>
      5-Year Returns
    </th>

    <th style={{ background: thColor }}>
      Since Inception
    </th>

    <th style={{ background: thColor }}>
      Inception Date
    </th>

    <th style={{ background: thColor }}>
      Morningstar
    </th>
  </tr>
</thead>

<tbody>
  {(comp.funds || []).map((f, index) => {

    const fn = f["Fund Name"]?.trim();

    const cleanFundName = fn
      ?.replace(/icici/gi, "")
      ?.replace(/tata/gi, "")
      ?.replace(/aia/gi, "")
      ?.replace(/prudential/gi, "")
      ?.trim();

    const isSelected =
      selectedFunds[comp._id] === fn;

    return (
      <tr
        key={fn}
        style={
          isSelected
            ? {
                background: selectedBg,
                fontWeight: "bold",
              }
            : {}
        }
      >
        <td style={{ textAlign: "center" }}>
          <input
            type="radio"
            name={`fund_${comp._id}`}
            value={fn}
            checked={isSelected}
            onChange={() =>
              onFundSelect(comp._id, fn)
            }
          />
        </td>

        <td>
          <b>{cleanFundName}</b>
        </td>

        <td style={{ textAlign: "center" }}>
          {f["5Y"] || "N/A"}
        </td>

        <td style={{ textAlign: "center" }}>
          {f["Since Inception"] || "N/A"}
        </td>

       <td style={{ textAlign: "center" }}>
  {f["Inception Date"]
    ? new Date(f["Inception Date"]).toLocaleDateString("en-GB")
    : "N/A"}
</td>

     <td style={{ textAlign: "center" }}>
  {isTata ? (
    <span className="star-ms">
      ★★★★★
    </span>
  ) : (
    f["Morningstar"] || "N/A"
  )}
</td>
      </tr>
    );
  })}
</tbody>

              </table>

            </div>

          </div>
        );
      })}
    </>
  );
};

export default FundSelection;